var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.muted
      ? 'text-muted font-weight-bold mr-2'
      : 'label label-light-success font-weight-bolder label-inline mr-2 label-lg'},[_vm._v(" "+_vm._s(_vm.tag)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }